import http from "../../plugins/axios";

export default {
  tree(data) {
    return http.get({
      url: "/la/admin/tenant/role/tree",
      data,
    });
  },
  menuTree(data) {
    return http.get({
      url: "/la/admin/tenant/role/menu/tree",
      data,
    });
  },
  add(data) {
    return http.post({
      url: "/la/admin/tenant/role/add",
      data,
    });
  },
  update(data) {
    return http.post({
      url: "/la/admin/tenant/role/update",
      data,
    });
  },
  remove(data) {
    return http.post({
      url: "/la/admin/tenant/role/delete",
      data,
      dataType: "form",
    });
  },
};
